import { ProductComparisonReducer } from '../../compare-page/reducers/ProductComparisonReducer';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
import { AEMScenes } from '@as-react/common-types';
const loadProductComparisonModule = () => ({
    id: AEMScenes.PRODUCT_COMPARISON,
    reducerMap: {
        productComparison: ProductComparisonReducer,
    },
    sagas: [deliveryPromiseSaga],
});
export default loadProductComparisonModule;
